<div class="custom-container">
    <!--Partido reciente-->
    <a *ngIf="recentMatch" [routerLink]="'/db/matches/detail/'+recentMatch._id">
        <match-result [match]="recentMatch"></match-result>
    </a>

    <h3>Rumores recientes</h3>
    <div class="rumores-carousel">
        <div class="rumores-wrapper">
            <a class="rumor-card" *ngFor="let rumor of rumores" [routerLink]="'/news/rumores/'+rumor._id">
                <rumores-card [rumor]="rumor"></rumores-card>
            </a>
            <!-- Duplicamos el contenido para animación fluida -->
            <a class="rumor-card" *ngFor="let rumor of rumores" [routerLink]="'/news/rumores/'+rumor._id">
                <rumores-card [rumor]="rumor"></rumores-card>
            </a>
        </div>
    </div>

    <mat-divider></mat-divider>

    <!--<p>Bienvenido al portal oficial de Atlético Stats. El hogar de la afición colchonera en internet. Descubre aquí tus secciones favoritas de esta web:</p>-->
    <div class="sections">
        <button *ngFor="let section of favSections" mat-button [routerLink]="section.link">
            {{ !isMobile ? section.name : section.shortName}}
        </button>
    </div>
    <mat-divider></mat-divider>

    <div class="newsletter-wrapper">
        <a class="newsletter-banner" routerLink="/news/newsletter">
            <div class="buzon"><h2>📬</h2></div>
            <div class="newsletter-text">
                <h2>¡APÚNTATE A NUESTRA NEWSLETTER!</h2>
                <p>Recibe en exclusiva contenido sobre la actualidad del Atleti directamente en tu correo.</p>
            </div>
        </a>
    </div>

    <div class="column-container">
        <div class="main-column">
            <h2>ÚLTIMOS ARTÍCULOS</h2>
            <div *ngFor="let article of articles" class="articles-wrapper">
                <a [routerLink]="'/news/' + article._id">
                    <articles-card [article]="article"></articles-card>
                </a>
            </div>
            <div class="divider"></div>
            <h2>VÍDEOS RECIENTES</h2>
            <youtube></youtube>
        </div>
        <div class="secondary-column">
            <minicalendar-component></minicalendar-component>
            <qualy-table></qualy-table>
            <recent-news></recent-news>
        </div>
    </div>

    <h3>Mejoras en la web</h3>
    <div class="responsive-table">
        <table mat-table [dataSource]="upgrades">
            <!-- Date Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Fecha </th>
                <td mat-cell *matCellDef="let element"> {{ element.date | date }} </td>
            </ng-container>
            
            <!-- Upgrade Column -->
            <ng-container matColumnDef="upgrade">
                <th mat-header-cell *matHeaderCellDef>Actualización</th>
                <td mat-cell *matCellDef="let element"> 
                    {{element.upgrade}}
                </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="['date','upgrade']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['date','upgrade'];"></tr>
        </table>
    </div>
</div>  